import { render, staticRenderFns } from "./sortCard.vue?vue&type=template&id=046a50c4&scoped=true&"
import script from "./sortCard.vue?vue&type=script&lang=js&"
export * from "./sortCard.vue?vue&type=script&lang=js&"
import style0 from "./sortCard.vue?vue&type=style&index=0&id=046a50c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046a50c4",
  null
  
)

export default component.exports